// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"h6AG3":[function(require,module,exports) {
class NSSCartTemplate extends HTMLElement {
    constructor(){
        super();
        this.debug = false;
        this.initialized = false;
        this.currencyFormatter = new Intl.NumberFormat(`en-US`, {
            style: `currency`,
            currency: `USD`
        });
    }
    connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.initCartTemplate();
    }
    disconnectedCallback() {
        if (this.documentSubmitHandler) document.removeEventListener(`submit`, this.documentSubmitHandler);
        if (this.documentClickHandler) document.removeEventListener(`click`, this.documentClickHandler);
        this.initialized = false;
    }
    async apiAddToCart(e) {
        const formData = new FormData(e.target);
        try {
            const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                body: formData
            });
            const responseText = await response.text();
            let data = {};
            if (responseText) try {
                data = JSON.parse(responseText);
            } catch (error) {
                data = {};
            }
            if (!response.ok) return {
                status: response.status,
                message: data.message || `Request failed`,
                description: data.description || data.error || `Unable to add item to cart.`
            };
            if (!responseText) return {
                status: response.status,
                message: `Request failed`,
                description: `Empty response from cart API.`
            };
            return data;
        } catch (error) {
            console.error("Error:", error);
            return {
                status: `network_error`,
                message: `Request failed`,
                description: error?.message || `Network error while adding item to cart.`
            };
        }
    }
    async _postCartUpdate(body, fallbackDescription) {
        try {
            const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const responseText = await response.text();
            let data = {};
            if (responseText) try {
                data = JSON.parse(responseText);
            } catch (error) {
                data = {};
            }
            if (!response.ok || !responseText) return {
                status: response.status,
                message: data.message || `Request failed`,
                description: data.description || data.error || fallbackDescription
            };
            return data;
        } catch (error) {
            console.error("Error:", error);
            return {
                status: `network_error`,
                message: `Request failed`,
                description: error?.message || `Network error while updating cart.`
            };
        }
    }
    async apiUpdate(updates) {
        return this._postCartUpdate({
            updates
        }, `Unable to update cart.`);
    }
    async apiUpdateAttributes(attributes) {
        return this._postCartUpdate({
            attributes
        }, `Unable to update cart attributes.`);
    }
    async apiChange(changes) {
        try {
            const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(changes)
            });
            const responseText = await response.text();
            let data = {};
            if (responseText) try {
                data = JSON.parse(responseText);
            } catch (error) {
                data = {};
            }
            if (!response.ok || !responseText) return {
                status: response.status,
                message: data.message || `Request failed`,
                description: data.description || data.error || `Unable to change cart item.`
            };
            return data;
        } catch (error) {
            console.error("Error:", error);
            return {
                status: `network_error`,
                message: `Request failed`,
                description: error?.message || `Network error while changing cart item.`
            };
        }
    }
    async fetchCartSection() {
        const parser = new DOMParser(), sectionID = this.getAttribute(`nss-parent-section-id`);
        let markup = await (await fetch(`?section_id=${sectionID}`)).text();
        return parser.parseFromString(markup, "text/html");
    }
    getStatusRegion() {
        return this.querySelector(`[nss-cart-status]`);
    }
    announceStatus(message) {
        const statusEl = this.getStatusRegion();
        if (!statusEl || !message) return;
        statusEl.textContent = ``;
        requestAnimationFrame(()=>{
            statusEl.textContent = message;
        });
    }
    formatMoney(cents) {
        return this.currencyFormatter.format((cents || 0) / 100);
    }
    getItemTitle(cartItemEl) {
        return cartItemEl?.getAttribute(`data-product-title`) || `item`;
    }
    restoreItemControlFocus(lineKey, selectors = []) {
        if (!lineKey) return false;
        const itemEl = this.querySelector(`[nss-cart-item-reload="${lineKey}"]`);
        if (!itemEl) return false;
        for (const selector of selectors){
            const targetEl = itemEl.querySelector(selector);
            if (targetEl && typeof targetEl.focus === `function` && !targetEl.disabled) {
                targetEl.focus({
                    preventScroll: true
                });
                return true;
            }
        }
        return false;
    }
    restoreItemControlFocusByGroupIndex(index, selectors = []) {
        const itemGroups = [
            ...this.querySelectorAll(`.nss-cart__item-group`)
        ];
        if (itemGroups.length === 0) return false;
        const targetGroup = itemGroups[Math.min(index, itemGroups.length - 1)];
        if (!targetGroup) return false;
        for (const selector of selectors){
            const targetEl = targetGroup.querySelector(selector);
            if (targetEl && typeof targetEl.focus === `function` && !targetEl.disabled) {
                targetEl.focus({
                    preventScroll: true
                });
                return true;
            }
        }
        return false;
    }
    focusCartFallbackControl() {
        const fallbackEl = this.querySelector(`[nss-cart-event="qty-increment"], [nss-cart-event="qty-decrement"], [nss-cart-event="remove"], .nss-cart__header [nss-open-cart-drawer], .nss-cart__summary a, .nss-cart__summary button`);
        if (fallbackEl && typeof fallbackEl.focus === `function`) {
            fallbackEl.focus({
                preventScroll: true
            });
            return true;
        }
        return false;
    }
    updateItemCount(sectionEl) {
        const newProductListEl = sectionEl.querySelector(`.nss-cart__items`), itemCountEls = document.querySelectorAll(`[nss-cart-count]`);
        itemCountEls.forEach((itemCountEl)=>{
            itemCountEl.innerHTML = newProductListEl.getAttribute(`nss-cart-item-count`);
        });
        this.updateCountBadges(newProductListEl.getAttribute(`nss-cart-item-count`));
    }
    updateCountBadges(result) {
        const count = parseInt(result);
        if (count < 100) {
            const countEls = document.querySelectorAll(`[nss-cart-badge-count]`);
            countEls.forEach((countEl)=>{
                countEl.innerHTML = count;
                // Show/hide badge based on count
                if (count > 0) {
                    countEl.classList.remove("hidden");
                    countEl.style.display = "";
                } else {
                    countEl.classList.add("hidden");
                    countEl.style.display = "none";
                }
            });
        }
    }
    reloadElements(sectionEl) {
        const reloadEls = this.querySelectorAll(`[nss-cart-reload]`);
        reloadEls.forEach((reloadEl)=>{
            const reloadID = reloadEl.getAttribute(`nss-cart-reload`), updatedEl = sectionEl.querySelector(`[nss-cart-reload="${reloadID}"]`);
            if (updatedEl) reloadEl.replaceWith(updatedEl);
            else reloadEl.remove();
        });
    }
    reloadItemList(sectionEl) {
        const productListEl = this.querySelector(`.nss-cart__items`), newProductListEl = sectionEl.querySelector(`.nss-cart__items`);
        productListEl.replaceWith(newProductListEl);
    }
    reloadItem(sectionEl, line) {
        const reloadEl = this.querySelector(`[nss-cart-item-reload="${line}"]`);
        if (reloadEl) {
            const updatedEl = sectionEl.querySelector(`[nss-cart-item-reload="${line}"]`);
            if (updatedEl) reloadEl.replaceWith(updatedEl);
            else /**
         * Shopify has unexpectedly changed the line item ID, so we must reload
         * the entire item list.
         */ this.reloadItemList(sectionEl);
        }
    }
    async handleATC(e) {
        const result = await this.apiAddToCart(e);
        if (typeof result?.status !== `undefined`) {
            this.announceStatus(`${result.message}: ${result.description}`);
            return;
        }
        const addedQuantity = result?.quantity || 1;
        const addedTitle = result?.product_title || result?.title || `item`;
        window.NSS_CART_OPEN_ANNOUNCEMENT = `Added ${addedQuantity} ${addedTitle} to your cart.`;
        const sectionEl = await this.fetchCartSection();
        this.updateItemCount(sectionEl);
        this.reloadItemList(sectionEl);
        this.reloadElements(sectionEl);
        // this.refreshRecommendations();
        if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
    }
    async handleRemove(e) {
        const cartItemEl = e.target.closest(`.nss-cart__item`), cartItemGroupEl = cartItemEl.closest(`.nss-cart__item-group`), nextItemKey = cartItemGroupEl?.nextElementSibling?.querySelector(`.nss-cart__item`)?.getAttribute(`nss-cart-item-reload`) || cartItemGroupEl?.previousElementSibling?.querySelector(`.nss-cart__item`)?.getAttribute(`nss-cart-item-reload`), itemKey = cartItemEl.getAttribute(`nss-cart-item-key`), ogChildKeys = cartItemEl.getAttribute(`nss-cart-item-og-child-keys`)?.split(",").filter(Boolean) || [], itemTitle = this.getItemTitle(cartItemEl);
        const removedProduct = {
            product_id: cartItemEl.getAttribute(`data-product-id`),
            variant_id: cartItemEl.getAttribute(`data-variant-id`),
            variant_title: itemTitle,
            variant_sku: cartItemEl.getAttribute(`data-variant-sku`),
            price: cartItemEl.getAttribute(`data-price`),
            quantity: Number(cartItemEl.getAttribute(`data-quantity`)) || undefined
        };
        let updates = {};
        updates[itemKey] = 0;
        ogChildKeys.forEach((key)=>{
            updates[key] = 0;
        });
        const result = await this.apiUpdate(updates);
        if (typeof result.status !== "undefined") {
            const cartItemParentEl = cartItemEl.parentElement, cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
            cartErrorEl.textContent = `${result.message}: ${result.description}`;
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
            if (this.debug) console.log(`[NSS] Remove failed!`);
        } else {
            const sectionEl = await this.fetchCartSection();
            this.updateItemCount(sectionEl);
            this.reloadItemList(sectionEl);
            this.reloadElements(sectionEl);
            // trial_flavor_count is a cart-level attribute, not a line item
            // property, so removing the Warm-Up trial line doesn't clear it on
            // its own -- it would otherwise linger on the cart (and get sent
            // through checkout) even after the trial item it described is gone.
            // Only clear it once no trial item remains, since the section markup
            // (reloaded above) is the authoritative post-removal cart state.
            //
            // Also sweeps up the legacy trial_flavor_1 / trial_flavor_2 keys from
            // an earlier attempt at this tracking, so a cart that picked those up
            // doesn't carry them forever. Shopify drops an attribute whose value
            // is an empty string, so clearing a key that isn't there is a no-op.
            const staleTrialAttributes = {
                trial_flavor_count: "",
                trial_flavor_1: "",
                trial_flavor_2: ""
            };
            const hasStaleTrialAttributes = result.attributes && Object.keys(staleTrialAttributes).some((key)=>result.attributes[key]);
            if (hasStaleTrialAttributes && !this.querySelector(`[data-is-trial-item="true"]`)) this.apiUpdateAttributes(staleTrialAttributes).then((clearResult)=>{
                if (typeof clearResult?.status === `undefined`) return;
                // One retry for a transient failure -- this is a secondary
                // cleanup step, so it shouldn't block or re-render anything the
                // removal itself already completed, but a persisted stale
                // attribute silently following the cart to checkout is worth
                // logging if both attempts fail.
                return this.apiUpdateAttributes(staleTrialAttributes).then((retryResult)=>{
                    if (typeof retryResult?.status !== `undefined`) console.error(`[NSS] Failed to clear trial flavor cart attributes:`, retryResult);
                });
            });
            // Lets other parts of the page (e.g. the Warm-Up trial PDP, which
            // locks its Add to Cart when a trial is already in the cart) re-check
            // cart state without a page refresh.
            document.dispatchEvent(new CustomEvent(`nss:cart-item-removed`, {
                detail: {
                    productId: removedProduct.product_id
                }
            }));
            const cartSummary = `Cart subtotal ${this.formatMoney(result.total_price)}.`;
            this.announceStatus(`${itemTitle} removed from cart. ${cartSummary}`);
            Shopify.analytics.publish(`custom_product_removed_from_cart`, {
                product: removedProduct
            });
            const restored = this.restoreItemControlFocus(nextItemKey, [
                `[nss-cart-event="qty-increment"]`,
                `[name="updates[]"]`,
                `[nss-cart-event="remove"]`
            ]);
            if (!restored) this.focusCartFallbackControl();
        }
    }
    async handleQtyIncrement(e) {
        const cartItemEl = e.target.closest(`.nss-cart__item`), itemKey = cartItemEl.getAttribute(`nss-cart-item-key`), qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`), itemReloadKey = cartItemEl.getAttribute(`nss-cart-item-reload`), itemTitle = this.getItemTitle(cartItemEl), itemGroupIndex = [
            ...this.querySelectorAll(`.nss-cart__item-group`)
        ].indexOf(cartItemEl.closest(`.nss-cart__item-group`));
        let qtyMax = parseInt(qtyInputEl.getAttribute(`max`)), qtyCurrent = parseInt(qtyInputEl.value), qtyFinal = Math.min(qtyCurrent + 1, qtyMax), updates = {};
        updates[itemKey] = qtyFinal;
        const result = await this.apiUpdate(updates);
        if (typeof result.status !== "undefined") {
            const cartItemParentEl = cartItemEl.parentElement, cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
            cartErrorEl.textContent = `${result.message}: ${result.description}`;
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
        } else {
            const sectionEl = await this.fetchCartSection();
            this.updateItemCount(sectionEl);
            this.reloadItem(sectionEl, itemReloadKey);
            this.reloadElements(sectionEl);
            const cartSummary = `Cart subtotal ${this.formatMoney(result.total_price)}.`;
            this.announceStatus(`${itemTitle} quantity updated to ${qtyFinal}. ${cartSummary}`);
            const incrementRestored = this.restoreItemControlFocus(itemReloadKey, [
                `[nss-cart-event="qty-increment"]`,
                `[name="updates[]"]`
            ]);
            if (!incrementRestored) this.restoreItemControlFocusByGroupIndex(itemGroupIndex, [
                `[nss-cart-event="qty-increment"]`,
                `[name="updates[]"]`
            ]);
        }
    }
    async handleQtyDecrement(e) {
        const cartItemEl = e.target.closest(`.nss-cart__item`), itemKey = cartItemEl.getAttribute(`nss-cart-item-key`), qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`), itemReloadKey = cartItemEl.getAttribute(`nss-cart-item-reload`), itemTitle = this.getItemTitle(cartItemEl), itemGroupIndex = [
            ...this.querySelectorAll(`.nss-cart__item-group`)
        ].indexOf(cartItemEl.closest(`.nss-cart__item-group`));
        let qtyMin = parseInt(qtyInputEl.getAttribute(`min`)), qtyCurrent = parseInt(qtyInputEl.value), qtyFinal = Math.max(qtyCurrent - 1, qtyMin);
        // If quantity would be 0 or less, remove the item directly instead of updating
        if (qtyFinal <= 0) {
            this.handleRemove(e);
            return;
        }
        let updates = {};
        updates[itemKey] = qtyFinal;
        const result = await this.apiUpdate(updates);
        if (this.debug) console.log(`[NSS] handleQtyDecrement result:`, result);
        if (typeof result.status !== "undefined") {
            const cartItemParentEl = cartItemEl.parentElement, cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
            cartErrorEl.textContent = `${result.message}: ${result.description}`;
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
            if (this.debug) console.log(`[NSS] Quantity decrement failed!`);
        } else {
            const sectionEl = await this.fetchCartSection();
            this.updateItemCount(sectionEl);
            this.reloadItem(sectionEl, itemReloadKey);
            this.reloadElements(sectionEl);
            const cartSummary = `Cart subtotal ${this.formatMoney(result.total_price)}.`;
            this.announceStatus(`${itemTitle} quantity updated to ${qtyFinal}. ${cartSummary}`);
            const decrementRestored = this.restoreItemControlFocus(itemReloadKey, [
                `[nss-cart-event="qty-decrement"]`,
                `[name="updates[]"]`
            ]);
            if (!decrementRestored) this.restoreItemControlFocusByGroupIndex(itemGroupIndex, [
                `[nss-cart-event="qty-decrement"]`,
                `[name="updates[]"]`
            ]);
        }
    }
    async handleSetQuantity(e) {
        const cartItemEl = e.target.closest(`.nss-cart__item`), itemKey = cartItemEl.getAttribute(`nss-cart-item-key`), itemReloadKey = cartItemEl.getAttribute(`nss-cart-item-reload`), itemTitle = this.getItemTitle(cartItemEl), itemGroupIndex = [
            ...this.querySelectorAll(`.nss-cart__item-group`)
        ].indexOf(cartItemEl.closest(`.nss-cart__item-group`)), targetQty = parseInt(e.target.closest(`[nss-cart-event="set-quantity"]`)?.getAttribute(`data-target-quantity`));
        if (isNaN(targetQty)) {
            console.error("[NSS] Invalid target quantity");
            return;
        }
        // If quantity is 0 or less, remove the item directly instead of updating
        if (targetQty <= 0) {
            this.handleRemove(e);
            return;
        }
        let updates = {};
        updates[itemKey] = targetQty;
        const result = await this.apiUpdate(updates);
        if (typeof result.status !== "undefined") {
            const cartItemParentEl = cartItemEl.parentElement, cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
            cartErrorEl.textContent = `${result.message}: ${result.description}`;
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
        } else {
            const sectionEl = await this.fetchCartSection();
            this.updateItemCount(sectionEl);
            this.reloadItem(sectionEl, itemReloadKey);
            this.reloadElements(sectionEl);
            const cartSummary = `Cart subtotal ${this.formatMoney(result.total_price)}.`;
            this.announceStatus(`${itemTitle} quantity updated to ${targetQty}. ${cartSummary}`);
            const setQtyRestored = this.restoreItemControlFocus(itemReloadKey, [
                `[nss-cart-event="set-quantity"][data-target-quantity="${targetQty}"]`,
                `[name="updates[]"]`
            ]);
            if (!setQtyRestored) this.restoreItemControlFocusByGroupIndex(itemGroupIndex, [
                `[nss-cart-event="set-quantity"]`,
                `[name="updates[]"]`
            ]);
        }
    }
    async handleSubscriptionChange(e) {
        const cartItemEl = e.target.closest(`.nss-cart__item`), itemKey = cartItemEl.getAttribute(`nss-cart-item-key`), itemReloadKey = cartItemEl.getAttribute(`nss-cart-item-reload`), itemGroupIndex = [
            ...this.querySelectorAll(`.nss-cart__item-group`)
        ].indexOf(cartItemEl.closest(`.nss-cart__item-group`)), qtyInputEl = cartItemEl.querySelector(`[name="updates[]"]`), quantity = parseInt(qtyInputEl.value);
        let sellingPlanId = "";
        if ("BUTTON" == e.target.nodeName) sellingPlanId = e.target.getAttribute("data-selling-plan-id");
        else if ("SELECT" == e.target.nodeName) sellingPlanId = e.target.value == "onetime" ? "" : e.target.value;
        else if ("INPUT" == e.target.nodeName) // Handle checkbox - if checked, add subscription, if unchecked, remove it
        sellingPlanId = e.target.checked ? e.target.getAttribute("data-selling-plan-id") : "";
        let changes = {
            "id": itemKey,
            "quantity": quantity,
            "selling_plan": sellingPlanId
        };
        const result = await this.apiChange(changes);
        if (this.debug) console.log(`[NSS] handleSubscriptionChange result: ${result}`);
        if (typeof result.status !== "undefined") {
            const cartItemParentEl = cartItemEl.parentElement, cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
            cartErrorEl.textContent = `${result.message}: ${result.description}`;
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
            if (this.debug) console.log(`[NSS] Handle subscribe failed!`);
        } else {
            const sectionEl = await this.fetchCartSection();
            this.reloadItem(sectionEl, itemReloadKey);
            this.reloadElements(sectionEl);
            const subscriptionControlRestored = this.restoreItemControlFocus(itemReloadKey, [
                `[nss-cart-event="change-selling-plan"]`,
                `[nss-cart-event="switch-to-subscription"]`,
                `[name="updates[]"]`
            ]);
            if (!subscriptionControlRestored) this.restoreItemControlFocusByGroupIndex(itemGroupIndex, [
                `[nss-cart-event="change-selling-plan"]`,
                `[nss-cart-event="switch-to-subscription"]`,
                `[name="updates[]"]`
            ]);
        }
    }
    async handleBundleSubscriptionChange(e) {
        const cartItemEl = e.target.closest(`.nss-cart__item`), selectEl = e.target.closest(`select[nss-cart-event="change-bundle-selling-plan"]`);
        if (!cartItemEl || !selectEl) return;
        const selectedOptionEl = selectEl.options[selectEl.selectedIndex], childPlanMapRaw = selectedOptionEl?.getAttribute(`data-og-child-plan-map`) || ``, childPlanPairs = childPlanMapRaw.split(`||`).map((pair)=>pair.trim()).filter(Boolean), itemTitle = this.getItemTitle(cartItemEl);
        if (childPlanPairs.length === 0) {
            this.announceStatus(`Unable to update bundle frequency right now.`);
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
            return;
        }
        let firstError = null;
        for (const pair of childPlanPairs){
            const [childKey, childPlanId, childQuantityRaw] = pair.split(`::`);
            const childQuantity = parseInt(childQuantityRaw, 10);
            if (!childKey || !childPlanId) continue;
            const result = await this.apiChange({
                id: childKey,
                quantity: Number.isNaN(childQuantity) ? 1 : childQuantity,
                selling_plan: childPlanId
            });
            if (typeof result?.status !== `undefined`) {
                firstError = result;
                break;
            }
        }
        if (firstError) {
            const cartItemParentEl = cartItemEl.parentElement, cartErrorEl = cartItemParentEl.querySelector(`.nss-cart__item-error`);
            if (cartErrorEl) cartErrorEl.textContent = `${firstError.message}: ${firstError.description}`;
            cartItemEl.setAttribute(`nss-cart-item-loading`, false);
            return;
        }
        const sectionEl = await this.fetchCartSection();
        this.updateItemCount(sectionEl);
        this.reloadItemList(sectionEl);
        this.reloadElements(sectionEl);
        const selectedLabel = selectedOptionEl?.textContent?.trim();
        if (selectedLabel) this.announceStatus(`${itemTitle} frequency updated to ${selectedLabel}.`);
    }
    startItemLoading(e) {
        const cartItemEl = e.target.closest(`.nss-cart__item`);
        cartItemEl.setAttribute(`nss-cart-item-loading`, true);
    }
    async refreshCart() {
        const sectionEl = await this.fetchCartSection();
        this.updateItemCount(sectionEl);
        this.reloadItemList(sectionEl);
        this.reloadElements(sectionEl);
        if (typeof window.NSS_OPEN_CART_DRAWER === `function`) window.NSS_OPEN_CART_DRAWER();
    }
    initCartTemplate() {
        // Hide update btn
        // this.querySelector(`[nss-cart-btn-update]`).style.display = `none`;
        // Attach 'submit' events to nss-main as delegator
        const mainEl = document.querySelector(`[nss-main]`);
        window.NSS_REFRESH_AND_OPEN_CART = ()=>{
            this.refreshCart();
        };
        // Store handler references for cleanup
        this.documentSubmitHandler = (e)=>{
            if (e.target.classList.contains(`shopify-product-form`) || e.target.getAttribute(`action`) === `/cart/add`) {
                e.preventDefault();
                if (this.debug) console.log(`[NSS] ATC form intercepted!`);
                this.handleATC(e);
            }
        };
        document.addEventListener(`submit`, this.documentSubmitHandler);
        this.documentClickHandler = (e)=>{
            const clickedAddButton = e.target.closest(`[name="add"]`);
            let clickedName = clickedAddButton?.getAttribute(`name`);
            if (this.debug) console.log(`[NSS] clickedName:`, clickedName);
            if (clickedName === "add") {
                e.preventDefault();
                if (this.debug) console.log(`[NSS] ATC button click intercepted!`);
                const fakeEvent = {
                    target: clickedAddButton.closest(`form`)
                };
                this.handleATC(fakeEvent);
            }
        };
        document.addEventListener(`click`, this.documentClickHandler);
        // Attach other events to nss-cart-drawer as delegator
        this.addEventListener(`click`, (e)=>{
            const actionEl = e.target.closest(`[nss-cart-event]`);
            let eventType = actionEl?.getAttribute(`nss-cart-event`);
            if (!eventType) return;
            switch(eventType){
                case "remove":
                    e.preventDefault();
                    this.startItemLoading(e);
                    this.handleRemove(e);
                    break;
                case "qty-increment":
                    e.preventDefault();
                    this.startItemLoading(e);
                    this.handleQtyIncrement(e);
                    break;
                case "qty-decrement":
                    e.preventDefault();
                    this.startItemLoading(e);
                    this.handleQtyDecrement(e);
                    break;
                case "set-quantity":
                    e.preventDefault();
                    this.startItemLoading(e);
                    this.handleSetQuantity(e);
                    break;
            }
        });
        this.addEventListener("change", (e)=>{
            let eventType = e.target.closest(`[nss-cart-event]`)?.getAttribute(`nss-cart-event`);
            if (!eventType) return;
            switch(eventType){
                case "change-selling-plan":
                    e.preventDefault();
                    this.startItemLoading(e);
                    this.handleSubscriptionChange(e);
                    break;
                case "change-bundle-selling-plan":
                    e.preventDefault();
                    this.startItemLoading(e);
                    this.handleBundleSubscriptionChange(e);
                    break;
                case "switch-to-subscription":
                    e.preventDefault();
                    this.startItemLoading(e);
                    this.handleSubscriptionChange(e);
                    break;
            }
        });
    }
}
customElements.define("nss-cart-template", NSSCartTemplate);

},{}]},["h6AG3"], "h6AG3", "parcelRequire83e8")

//# sourceMappingURL=nss-cart-template.js.map
